
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SupervisorDashboard() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('monitoring');

  const stats = [
    { label: '监督项目', value: '18', icon: 'ri-eye-line', color: 'bg-red-500' },
    { label: '发现问题', value: '3', icon: 'ri-error-warning-line', color: 'bg-orange-500' },
    { label: '已处理', value: '15', icon: 'ri-checkbox-circle-line', color: 'bg-green-500' },
    { label: '合规率', value: '98.5%', icon: 'ri-shield-check-line', color: 'bg-blue-500' }
  ];

  const monitoringProjects = [
    {
      id: 1,
      name: '市政道路改造工程项目',
      code: 'ZB2024001',
      stage: '投标阶段',
      bidders: 12,
      status: '正常',
      lastCheck: '2024-01-15 14:30',
      complianceScore: 98
    },
    {
      id: 2,
      name: '办公楼装修工程',
      code: 'ZB2024002',
      stage: '评审阶段',
      bidders: 8,
      status: '正常',
      lastCheck: '2024-01-15 10:20',
      complianceScore: 95
    },
    {
      id: 3,
      name: '信息化系统建设项目',
      code: 'ZB2024003',
      stage: '开标阶段',
      bidders: 15,
      status: '待核查',
      lastCheck: '2024-01-14 16:45',
      complianceScore: 92
    }
  ];

  const issues = [
    {
      id: 1,
      project: '园林绿化工程',
      projectCode: 'ZB2024004',
      type: '资质问题',
      severity: '中',
      description: '投标企业资质证书即将过期',
      reportTime: '2024-01-15 09:30',
      status: '处理中'
    },
    {
      id: 2,
      project: '医疗设备采购',
      projectCode: 'ZB2024006',
      type: '流程问题',
      severity: '低',
      description: '公告发布时间不足法定期限',
      reportTime: '2024-01-14 15:20',
      status: '已处理'
    }
  ];

  const auditLogs = [
    { id: 1, action: '项目ZB2024001开标记录审查', result: '通过', time: '2024-01-15 14:30', operator: '监督员A' },
    { id: 2, action: '项目ZB2024002评审过程检查', result: '通过', time: '2024-01-15 10:20', operator: '监督员B' },
    { id: 3, action: '项目ZB2024003投标文件核查', result: '发现问题', time: '2024-01-14 16:45', operator: '监督员A' },
    { id: 4, action: '项目ZB2024004资质审核', result: '通过', time: '2024-01-14 14:15', operator: '监督员C' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button onClick={() => navigate('/')} className="text-gray-600 hover:text-gray-900 cursor-pointer whitespace-nowrap">
                <i className="ri-arrow-left-line text-xl"></i>
              </button>
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-red-500 rounded-lg flex items-center justify-center">
                  <i className="ri-shield-check-line text-xl text-white"></i>
                </div>
                <div>
                  <h1 className="text-xl font-bold text-gray-900">监督方工作台</h1>
                  <p className="text-sm text-gray-500">招投标监督管理办公室</p>
                </div>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <button className="px-4 py-2 text-gray-600 hover:text-gray-900 whitespace-nowrap cursor-pointer">
                <i className="ri-notification-line text-xl"></i>
              </button>
              <button className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 whitespace-nowrap cursor-pointer">
                <i className="ri-alert-line mr-2"></i>
                上报问题
              </button>
            </div>
          </div>
        </div>
      </header>

      <div className="p-6">
        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
          {stats.map((stat, index) => (
            <div key={index} className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow">
              <div className="flex items-center justify-between mb-4">
                <div className={`w-12 h-12 ${stat.color} rounded-lg flex items-center justify-center`}>
                  <i className={`${stat.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-1">{stat.value}</div>
              <div className="text-sm text-gray-500">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Main Content */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-xl shadow-sm">
              <div className="border-b border-gray-200 px-6">
                <div className="flex space-x-8">
                  {[
                    { id: 'monitoring', label: '项目监督', icon: 'ri-eye-line' },
                    { id: 'issues', label: '问题管理', icon: 'ri-error-warning-line' },
                    { id: 'audit', label: '审计日志', icon: 'ri-file-list-3-line' }
                  ].map((tab) => (
                    <button
                      key={tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      className={`py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer transition-colors ${
                        activeTab === tab.id
                          ? 'border-red-600 text-red-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700'
                      }`}
                    >
                      <i className={`${tab.icon} mr-2`}></i>
                      {tab.label}
                    </button>
                  ))}
                </div>
              </div>

              <div className="p-6">
                {activeTab === 'monitoring' && (
                  <div className="space-y-4">
                    {monitoringProjects.map((project) => (
                      <div key={project.id} className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
                        <div className="flex items-start justify-between mb-4">
                          <div className="flex-1">
                            <div className="flex items-center space-x-3 mb-2">
                              <h3 className="text-lg font-bold text-gray-900">{project.name}</h3>
                              <span className={`px-3 py-1 text-xs font-semibold rounded-full whitespace-nowrap ${
                                project.status === '正常' ? 'bg-green-100 text-green-700' : 'bg-orange-100 text-orange-700'
                              }`}>
                                {project.status}
                              </span>
                            </div>
                            <div className="flex items-center space-x-6 text-sm text-gray-600 mb-3">
                              <span><i className="ri-price-tag-3-line mr-1"></i>{project.code}</span>
                              <span><i className="ri-time-line mr-1"></i>{project.stage}</span>
                              <span><i className="ri-team-line mr-1"></i>{project.bidders}家投标企业</span>
                            </div>
                          </div>
                        </div>
                        <div className="grid grid-cols-2 gap-4 mb-4 p-4 bg-gray-50 rounded-lg">
                          <div>
                            <div className="text-xs text-gray-500 mb-1">合规评分</div>
                            <div className="flex items-center">
                              <div className="text-2xl font-bold text-green-600">{project.complianceScore}</div>
                              <div className="ml-2 text-sm text-gray-500">/100</div>
                            </div>
                          </div>
                          <div>
                            <div className="text-xs text-gray-500 mb-1">最后检查</div>
                            <div className="text-sm font-semibold text-gray-900">{project.lastCheck}</div>
                          </div>
                        </div>
                        <div className="flex items-center justify-end space-x-2">
                          <button className="px-4 py-2 text-red-600 border border-red-600 rounded-lg hover:bg-red-50 whitespace-nowrap cursor-pointer">
                            查看详情
                          </button>
                          <button className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 whitespace-nowrap cursor-pointer">
                            开始监督
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {activeTab === 'issues' && (
                  <div className="space-y-4">
                    {issues.map((issue) => (
                      <div key={issue.id} className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
                        <div className="flex items-start justify-between mb-4">
                          <div className="flex-1">
                            <div className="flex items-center space-x-3 mb-2">
                              <h3 className="text-lg font-bold text-gray-900">{issue.project}</h3>
                              <span className={`px-3 py-1 text-xs font-semibold rounded-full whitespace-nowrap ${
                                issue.severity === '高' ? 'bg-red-100 text-red-700' :
                                issue.severity === '中' ? 'bg-orange-100 text-orange-700' :
                                'bg-yellow-100 text-yellow-700'
                              }`}>
                                {issue.severity}级
                              </span>
                              <span className={`px-3 py-1 text-xs font-semibold rounded-full whitespace-nowrap ${
                                issue.status === '已处理' ? 'bg-green-100 text-green-700' : 'bg-blue-100 text-blue-700'
                              }`}>
                                {issue.status}
                              </span>
                            </div>
                            <div className="text-sm text-gray-600 mb-3">
                              <i className="ri-price-tag-3-line mr-1"></i>{issue.projectCode}
                              <span className="mx-2">|</span>
                              <i className="ri-error-warning-line mr-1"></i>{issue.type}
                            </div>
                            <div className="p-3 bg-orange-50 rounded-lg mb-3">
                              <p className="text-sm text-gray-700">{issue.description}</p>
                            </div>
                            <div className="text-xs text-gray-500">
                              <i className="ri-time-line mr-1"></i>上报时间: {issue.reportTime}
                            </div>
                          </div>
                        </div>
                        <div className="flex items-center justify-end space-x-2">
                          <button className="px-4 py-2 text-red-600 border border-red-600 rounded-lg hover:bg-red-50 whitespace-nowrap cursor-pointer">
                            查看详情
                          </button>
                          {issue.status === '处理中' && (
                            <button className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 whitespace-nowrap cursor-pointer">
                              处理问题
                            </button>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {activeTab === 'audit' && (
                  <div className="space-y-3">
                    {auditLogs.map((log) => (
                      <div key={log.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
                        <div className="flex items-center space-x-4 flex-1">
                          <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                            log.result === '通过' ? 'bg-green-100' : 'bg-orange-100'
                          }`}>
                            <i className={`${
                              log.result === '通过' ? 'ri-checkbox-circle-line text-green-600' : 'ri-error-warning-line text-orange-600'
                            } text-xl`}></i>
                          </div>
                          <div className="flex-1">
                            <div className="flex items-center space-x-3 mb-1">
                              <span className="font-semibold text-gray-900">{log.action}</span>
                              <span className={`px-2 py-1 text-xs font-semibold rounded-full whitespace-nowrap ${
                                log.result === '通过' ? 'bg-green-100 text-green-700' : 'bg-orange-100 text-orange-700'
                              }`}>
                                {log.result}
                              </span>
                            </div>
                            <div className="flex items-center space-x-4 text-sm text-gray-500">
                              <span><i className="ri-user-line mr-1"></i>{log.operator}</span>
                              <span><i className="ri-time-line mr-1"></i>{log.time}</span>
                            </div>
                          </div>
                        </div>
                        <button className="p-2 text-gray-400 hover:text-gray-600 cursor-pointer whitespace-nowrap">
                          <i className="ri-more-2-fill"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            {/* Compliance Overview */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-4">合规概览</h3>
              <div className="space-y-4">
                <div>
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm text-gray-600">整体合规率</span>
                    <span className="text-2xl font-bold text-green-600">98.5%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div className="bg-green-600 h-2 rounded-full" style={{ width: '98.5%' }}></div>
                  </div>
                </div>
                <div className="pt-4 border-t border-gray-200 space-y-3">
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-gray-600">流程合规</span>
                    <span className="font-semibold text-gray-900">99%</span>
                  </div>
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-gray-600">资质合规</span>
                    <span className="font-semibold text-gray-900">98%</span>
                  </div>
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-gray-600">文件合规</span>
                    <span className="font-semibold text-gray-900">97%</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Actions */}
            <div className="bg-gradient-to-br from-red-500 to-red-600 rounded-xl shadow-sm p-6 text-white">
              <h3 className="text-lg font-bold mb-4">监督工具</h3>
              <div className="space-y-3">
                <button className="w-full px-4 py-3 bg-white/20 hover:bg-white/30 rounded-lg text-left whitespace-nowrap cursor-pointer transition-colors">
                  <i className="ri-file-search-line mr-2"></i>
                  文件审查
                </button>
                <button className="w-full px-4 py-3 bg-white/20 hover:bg-white/30 rounded-lg text-left whitespace-nowrap cursor-pointer transition-colors">
                  <i className="ri-shield-check-line mr-2"></i>
                  合规检查
                </button>
                <button className="w-full px-4 py-3 bg-white/20 hover:bg-white/30 rounded-lg text-left whitespace-nowrap cursor-pointer transition-colors">
                  <i className="ri-alert-line mr-2"></i>
                  问题上报
                </button>
                <button className="w-full px-4 py-3 bg-white/20 hover:bg-white/30 rounded-lg text-left whitespace-nowrap cursor-pointer transition-colors">
                  <i className="ri-file-list-3-line mr-2"></i>
                  生成报告
                </button>
              </div>
            </div>

            {/* Regulations */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-4">法规文件</h3>
              <div className="space-y-3">
                <a href="#" className="block p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                  <div className="flex items-center space-x-3">
                    <i className="ri-file-text-line text-red-600"></i>
                    <span className="text-sm text-gray-900 font-medium">招标投标法</span>
                  </div>
                </a>
                <a href="#" className="block p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                  <div className="flex items-center space-x-3">
                    <i className="ri-file-text-line text-red-600"></i>
                    <span className="text-sm text-gray-900 font-medium">政府采购法</span>
                  </div>
                </a>
                <a href="#" className="block p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                  <div className="flex items-center space-x-3">
                    <i className="ri-file-text-line text-red-600"></i>
                    <span className="text-sm text-gray-900 font-medium">监督管理办法</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
